import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { GlobalConfig } from './app/shared/configs/global-config';
import { redirecionarCallbackDoSso } from './app/sso-poc/sso-poc-bootstrap';

if (location.hostname !== 'localhost') {
  enableProdMode();
}

// AP-1161: no-op com a feature flag desligada (padrao).
const aguardandoRedirectDoSso = redirecionarCallbackDoSso();

setTimeout(() => {
  localStorage.setItem('cookieConsent', environment.cookieConsent);
}, GlobalConfig.MOUSEENTER_TIMEOUT);

if (!aguardandoRedirectDoSso) {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
}
